import { SET_ADD_RESOURCE_REQUEST,
        SET_ADD_RESOURCE_SUCCESS,
        SET_ADD_RESOURCE_ERROR,
        SET_REMOVE_RESOURCE,
        SET_INCLUDE_RESOURCE
 } from './../../../constants/closeLoop/apmDashboard/listResourcesConstants';


const initialState = {
    loading: false,
    error: "",
    resources: []
};

export const listResources = (state=initialState, action) => {
    switch(action.type) {
        case SET_ADD_RESOURCE_REQUEST:
            return {
                ...state,
                loading: true,
                error: ""
            }

        case SET_ADD_RESOURCE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: "",
                resources: action.payload
            }

        case SET_ADD_RESOURCE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        case SET_REMOVE_RESOURCE:
            return {
                ...state,
                loading: false,
                error: "",
                resources: state.resources.filter(item => item !== action.item)
            }

        case SET_INCLUDE_RESOURCE:
            return {
                ...state,
                loading: false,
                error: "",
                resources: [
                    ...state.resources,
                    action.payload
                ]
            }

        default:
            return state;
    }
};